module.exports = __webpack_public_path__ + "static/maquette.bf2d1124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartUp/img/maquette.jpg
// module id = 830
// module chunks = 110243015079028